import React, { useEffect, useState } from 'react';
import { useForm } from 'react-hook-form';
import api from "../services/api";
import IApagar from '../interfaces/IApagar';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { useAuth } from '../providers/auth';
import { useToast } from '../context/ToastContext';
import Loading from '../components/Loading';
import { SCButton } from '../components';

interface Props {
    LiquidaFaturaId?: number;
    setFaturaCartaoQuitadaDetalhes(param: boolean): void;
    reload(): void;
}

const FaturaCartaoQuitadaDetalhes: React.FC<Props> = ({ setFaturaCartaoQuitadaDetalhes, LiquidaFaturaId, reload }) => {
    // é utilizado para o cadastro da ajuda da tela (todas as telas devem ter essa informação)
    // por padrão vamos utilizar o mesmo nome do componente

    const { periodoSelecionado, usuario } = useAuth();
    const tarefa = 'FaturaCartaoQuitadaDetalhe';

    const [aPagar, setAPagar] = useState<any>([]);
    const [loading, setLoading] = useState(false)

    const methods = useForm();
    const { control, watch, getValues, setValue, reset } = methods;

    const load = async () => {
        const result2 = await api.get('/apagar/listLiquidaFatura', {
            params: {
                FaturasQuitadas: true,
                LiquidaFaturaId: LiquidaFaturaId
            }
        })
        if (result2.data) {
            setAPagar(result2.data)
        } else {
            setAPagar([])
        }

        setLoading(false)
    };

    useEffect(() => {
        load();
    }, []);

    const cancelar = (e: any) => {
        setFaturaCartaoQuitadaDetalhes(false);
        reset();
    }

    return (
        <div className="grid crud-demo">
            <div className="col-12">
                {loading ? <Loading /> : (
                    <DataTable
                        size='small'
                        stripedRows
                        value={aPagar}
                        dataKey="ApagarId"
                        currentPageReportTemplate="{first} a {last} de {totalRecords}"
                        emptyMessage="Nenhum registro encontrado."
                        header={null}
                        responsiveLayout="scroll">
                        <Column field="NumeroDocumento" header="Nº Documento" sortable headerStyle={{ width: '10%' }} ></Column>
                        <Column field="DataPagamento" header="Data Pagamento" sortable body={(rowData: any) => {
                            if (rowData.DataPagamento) {
                                return (
                                    <span>{rowData.DataPagamentoString}</span>
                                );
                            }
                            return null;
                        }} style={{ width: '16%' }} />
                        <Column field="NomeCartao" header="Cartão Institucional" sortable headerStyle={{ width: '20%' }} ></Column>
                        <Column field="Nome" header="Credor" sortable headerStyle={{ width: '20%' }} ></Column>
                        <Column field="Referente" header="Referente" sortable headerStyle={{ width: '20%' }} ></Column>

                        <Column field="Valor" header="Valor" align='center' sortable body={(rowData: any) => {
                            return (
                                <span>R$ {rowData.Valor?.toFixed(2).replace('.', ',')}</span>
                            );
                        }} style={{ width: '15%' }}
                        />
                    </DataTable>
                )}
                <div className="flex flex-1 justify-content-between pt-3 px-2">
                    <SCButton label="Cancelar" icon="pi pi-times" className="p-button w-auto p-button-danger p-button-outlined" type='button' onClick={cancelar} />
                </div>
            </div>
        </div>
    );
};

export default FaturaCartaoQuitadaDetalhes;